import { CharacteristicsObject } from 'src/app/models/characteristics/characteristics.model';
import { StringUtils } from 'src/app/services/utils/string.utils';

export class AddressesObject {

    constructor(private format: string, private addresses: CharacteristicsObject) {

    }

    public static create() {
        return new AddressesObject(StringUtils.NOT_AVALIABLE, CharacteristicsObject.create());
    }

    public getFormat(): string {
        return this.format;
    }

    public getAddresses(): CharacteristicsObject {
        return this.addresses;
    }
}
